import { render } from "./SidebarNavProvider.vue?vue&type=template&id=1e87ef28"
import script from "./SidebarNavProvider.vue?vue&type=script&lang=js"
export * from "./SidebarNavProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__